
import { EventList } from '@/components/shared/EventList';
import { HomeHeader } from '@/components/home/HomeHeader';
import { useUser } from '@supabase/auth-helpers-react';
import { useUserEvents, UserEvent } from '@/hooks/useUserEvents';

export const Home = () => {
  const user = useUser();
  const { events, isLoading } = useUserEvents();
  
  // Filter out archived events
  const activeEvents = events?.filter(event => !event.archived) || [];
  
  // Filter out duplicate events by event_id
  const uniqueEvents = activeEvents.reduce((unique: UserEvent[], event) => {
    // Check if we already have this event in our array
    const exists = unique.some(e => e.event_id === event.event_id);
    
    // If not, add it to our array
    if (!exists) {
      unique.push(event);
    }
    
    return unique;
  }, []);

  return (
    <div className="container max-w-2xl mx-auto p-4">
      <HomeHeader />
      <EventList 
        events={uniqueEvents as UserEvent[]}
        isLoading={isLoading} 
        userId={user?.id} 
      />
    </div>
  );
};
